import styled, { css } from "styled-components";

const SIZES = {
    SMALL: 30,
    MEDIUM: 50,
    LARGE: 80
};

export const StyledAvatar = styled.div`
    background-color: ${({ theme }) => theme.colors.mediumGrey};
    border-radius: 50%;
    overflow: hidden;
    ${({ size }) => size && css`
        height: ${({ size }) => `${SIZES[size.toUpperCase()]}px`};
        width: ${({ size }) => `${SIZES[size.toUpperCase()]}px`};
        ${({ gutter }) => gutter && css`
            padding: ${({ size }) => `calc(${SIZES[size.toUpperCase()]}px * 0.25)`};
        `};
    `};
    ${({ customSize }) => customSize && css`
        height: ${({ customSize }) => `${customSize}px`};
        width:  ${({ customSize }) => `${customSize}px`};
        ${({ gutter }) => gutter && css`
            padding: ${({ customSize }) => `calc(${customSize}px * 0.25)`};
        `};
    `};
`;

export const StyledShortcut = styled.p`
    ${({ theme }) => theme.fonts.comfortaaBold};
    font-size: 16px;
    color: ${({ theme }) => theme.colors.white};
    text-align: center;
`;